import { render, staticRenderFns } from "./publisher.vue?vue&type=template&id=97f59906&scoped=true"
import script from "./publisher.vue?vue&type=script&lang=js"
export * from "./publisher.vue?vue&type=script&lang=js"
import style0 from "./publisher.vue?vue&type=style&index=0&id=97f59906&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97f59906",
  null
  
)

export default component.exports